import AboutUs from "@/assets/imgs/about-us.png";
import { SEO } from "@/components/SEO/SEO";

export const AboutUsPage = () => {
  return (
    <section className="container my-5">
      <SEO
        title="Quiénes somos"
        description="Conoce OpenMatic, la plataforma de vending online que conecta máquinas con personas."
        url="/about-us"
      />
      <div className="row d-flex justify-content-center">
        <div className="col-md-4 col-12 mb-md-0 p-md-4">
          <h5 className="mt-0 inter-bold about-us-title-1">¿Quiénes somos?</h5>
          <img
            className="card-image"
            src={AboutUs}
            alt="about-us"
            width="400"
          />
        </div>

        <div className="col-md-8 p-2 ps-md-0">
          <div className="row" style={{ paddingTop: "5rem" }}></div>

          <p className="about-us-title text-start">
            Automatización, eficiencia y crecimiento
          </p>
          <p className="inter-regular about-us-text">
            OpenMatic es el nuevo sistema de compra con puntos de entrega
            automática. Con nuestra tecnología podrás desarrollar un nuevo canal
            de ventas y distribución en cualquier parte del país de forma
            rápida, escalable y a bajo costo. Consulta en línea tus informes de
            ventas, reposición e inventario y optimiza tu operación. Atrae más
            clientes entregando promociones, ofertas y descuentos con un solo
            click. Tus clientes pagan en la App y retiran la compra cuando
            quieran, sin hacer filas e incluso 24/7.
          </p>
          <hr />
          <p className="about-us-title">Misión</p>
          <div className="about-us-text">
            Consulta en línea tus informes de ventas, reposición e inventario y
            optimiza tu operación. Atrae más clientes entregando promociones,
            ofertas y descuentos con un solo click. Tus clientes pagan en la App
            y retiran la compra cuando quieran, sin hacer filas e incluso 24/7.
          </div>
          <hr />
          <p className="about-us-title">Visión</p>
          <div className="about-us-text">
            Consulta en línea tus informes de ventas, reposición e inventario y
            optimiza tu operación. Atrae más clientes entregando promociones,
            ofertas y descuentos con un solo click. Tus clientes pagan en la App
            y retiran la compra cuando quieran, sin hacer filas e incluso 24/7.
          </div>

          <div className="container-fluid mx-0">
            {/* <div className="row">
              <div className="col-6 font16 inter-regular text-black-50">
                <div className="d-flex align-items-center">
                  <span>Cantidad</span>
                </div>
              </div>
            </div> */}
            {/* <hr /> */}
          </div>
          <div className="container-fluid ">
            <div className="row">
              <div className="col d-flex justify-content-start"></div>
            </div>
          </div>
        </div>

        {/* <div className="col-md-2"></div> */}
      </div>
      {/* <div className="row-cols-3 container">
        <div className="col-12">
          <div className="border border-1 rounded p-4">
            <div className="row">
              <div className="col-6">
                <h5 className="about-us-details">Misión</h5>
              </div>
              <div className="col-6">
                <h5 className="about-us-details">Visión</h5>
              </div>

              <hr />
            </div>

            <div className="row">
              <div className="col-6 about-us-col-6">
                <p>
                  Entregar soluciones innovadoras de entrega automática de
                  productos para nuestros clientes, integrando tecnologías que
                  otorguen una buena relación costo-beneficio, de modo tal que
                  la incorporación de ellas en sus actividades sean una
                  verdadera oportunidad de negocio.
                </p>
              </div>
              <div className="col-6 about-us-col-6">
                <p>
                  OPEN MATIC aspira a ser un socio estratégico e innovador,
                  aportando siempre soluciones integrales para el desarrollo de
                  sus proyectos y participando activamente en el crecimiento de
                  sus negocios como un nuevo canal de ventas.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </section>
  );
};
